import {Component, Input, OnInit} from '@angular/core';
import {GlobalDataService, IsAdmin, ResetAuthToken} from '../global-data.service';
import {AuthenticationService} from '../authentication-service.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Customer, CustomerOptions} from '../app-models/models';
import {CreateCustomerService} from '../create-customer.service';

@Component({
  selector: 'app-create-customer',
  templateUrl: './create-customer.component.html',
  styleUrls: ['./create-customer.component.css'],
  providers: [CreateCustomerService]
})
export class CreateCustomerComponent implements OnInit {

  private compObj: Customer = new Customer();
  private compOptions: CustomerOptions;
  private actionMessage: string;
  private actionStatus = true;

  constructor(private globalDataService: GlobalDataService, private authService: AuthenticationService,
              private router: Router, private componentService: CreateCustomerService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.authenticate();
  }

  authenticate(): void {
    if (this.globalDataService.token == null || !IsAdmin.call(this)) {
      this.router.navigate(['/login']);
    } else {
      this.authService.Authenticate().then(this.main.bind(this))
        .catch(this.handleAuthenticationError.bind(this));
    }
  }

  handleAuthenticationError(e) {
    ResetAuthToken.call(this);
  }

  main(result): void {
    let id: string;
    this.route.queryParams
      .subscribe(params => {
        id = params['orderId'];
      });
    if (id != null) {
      this.componentService.getDataFromOrder(id).then(this.mainSuccessOne.bind(this))
        .catch(this.mainFail.bind(this));
    } else {
      this.componentService.getData().then(this.mainSuccessTwo.bind(this))
        .catch(this.mainFail.bind(this));
    }
  }

  mainSuccessOne(result) {
    this.compObj = result;
  }

  mainSuccessTwo(result) {
    this.compObj.options = result;
  }

  mainFail(e) {
    if (e.status === 401) {
      ResetAuthToken.call(this);
    }
  }

  onSubmit() {
    this.actionMessage = null;
    this.componentService.createCustomer(this.compObj).then(this.submitSuccess.bind(this))
      .catch(this.submitFail.bind(this));
  }

  submitFail(e) {
    if (e.status === 401) {
      ResetAuthToken.call(this);
    } else {
      this.actionStatus = false;
      this.actionMessage = 'Submit Failed!';
    }
  }

  submitSuccess(result = null) {
    this.actionStatus = true;
    this.actionMessage = 'Success!';
  }

}



// WEBPACK FOOTER //
// ./src/app/create-customer/create-customer.component.ts